import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MemberQuery, NotificationCenterMessageView, NotificationCenterQuery, NotificationCenterService } from '@fgb/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-notification-hub',
  templateUrl: './notification-hub.component.html',
  styleUrls: ['./notification-hub.component.scss'],
})
export class NotificationHubComponent implements OnInit, OnDestroy {
  @Output() goToNotification = new EventEmitter();
  isOpen$: Observable<boolean>;
  isOpen: boolean;
  notifications$: Observable<NotificationCenterMessageView[]>;
  showPrev$: Observable<boolean>;
  showNext$: Observable<boolean>;
  unseenNotificationCount$: Observable<number>;
  private _destroyed$ = new Subject<void>();

  constructor(
    private notificationService: NotificationCenterService,
    private notificationQuery: NotificationCenterQuery,
    private memberQuery: MemberQuery
  ) {}

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  ngOnInit() {
    this.memberQuery.userContext$.pipe(takeUntil(this._destroyed$)).subscribe((user) => {
      if (user && user.lcid) {
        this.notifications$ = this.notificationQuery.selectAllPagedView(+user.lcid);
      }
    });

    this.isOpen$ = this.notificationQuery.isOpen$.pipe(
      tap((isOpen) => {
        this.isOpen = isOpen;
        if (isOpen) {
          this.notificationService.startNotificationCheck();
        }
      })
    );

    this.showPrev$ = this.notificationQuery.showPrev$;
    this.showNext$ = this.notificationQuery.showNext$;

    this.unseenNotificationCount$ = this.notificationQuery.unseenNotificationsCount$;
  }

  /**
   * Toggle the isOpen, used when we show and hide the notification center
   */
  toggleIsOpen() {
    this.notificationService.updateIsOpen(!this.isOpen);
  }

  incrementPage() {
    this.notificationService.incrementPage();
  }

  decrementPage() {
    this.notificationService.decrementPage();
  }

  toggleNotificationCenter(open: boolean) {
    this.notificationService.updateIsOpen(open);
  }
}
